<template>
  <Bundle
    v-if="
      isBouyguesOffer(mobilePlanOffer) && mobilePlanOffer.type !== 'IN_STORE'
    "
  >
    <BouyguesMobilePlan
      data-qa="mobile-plan"
      data-test="bouygues-mobile-plan"
      :offer="mobilePlanOffer"
      @remove="handleRemoveMobilePlan"
    />
  </Bundle>
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import { isBouyguesOffer } from '@backmarket/nuxt-layer-checkout/utils/mobilePlan/isBouyguesOffer'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import Bundle from '../Bundle/Bundle.vue'

import translations from './SelectedMobilePlan.translations'
import BouyguesMobilePlan from './components/BouyguesMobilePlan/BouyguesMobilePlan.vue'

defineProps<{
  mobilePlanOffer: MobilePlanOffer
}>()

const i18n = useI18n()
const { openErrorToast, openSuccessToast } = useTheToast()
const $httpFetch = useHttpFetch()

const emit = defineEmits<{
  (e: 'remove'): void
}>()

async function handleRemoveMobilePlan(offerId: string) {
  try {
    await $httpFetch('/bm/cart/services', {
      method: 'DELETE',
      body: { offerId },
    })

    openSuccessToast({
      title: i18n(translations.mobilePlanRemovalSuccessfulTitle),
      content: i18n(translations.mobilePlanRemovalSuccessfulContent),
    })

    emit('remove')
  } catch (error) {
    openErrorToast()

    throw error
  }
}
</script>
